export const eventsState = {
    events: [],
    loading: false,
    currentPage: 1,
    lastPage: 1,
};
